import React from 'react';
import type { Question } from '../../../../types/publicForm.types';
import { useFormContext } from '../../../../public_home/components/forms/FormContext';
import { V1FormQuestion } from './V1FormQuestion';

interface V1ConditionalQuestionsProps {
  parentQuestion: Question;
  selectedValue: any;
  primaryColor: string;
}

/**
 * V1 Conditional Questions Component - FROZEN
 *
 * Displays child questions when their parent answer is selected.
 * V1 forms show all child questions inline without pages.
 */
export const V1ConditionalQuestions: React.FC<V1ConditionalQuestionsProps> = ({
  parentQuestion,
  selectedValue,
  primaryColor,
}) => {
  const { state } = useFormContext();

  if (!selectedValue || !parentQuestion.answers) {
    return null;
  }

  // Get all selected answer IDs
  const selectedAnswerIds = Array.isArray(selectedValue) ? selectedValue : [selectedValue];

  // Collect all conditional questions from selected answers
  const conditionalQuestions: React.ReactNode[] = [];

  selectedAnswerIds.forEach(answerId => {
    const answer = parentQuestion.answers?.find(a => String(a.id) === String(answerId));
    if (answer?.childQuestions && answer.childQuestions.length > 0) {
      answer.childQuestions
        .filter(childQ => !childQ._destroy)
        .forEach(childQuestion => {
          // Only render if this child question is in the visible set
          if (state.visibleChildQuestions.has(String(childQuestion.id))) {
            conditionalQuestions.push(
              <div key={childQuestion.id} className="ml-8 mt-4 p-4 bg-gray-50 rounded-lg border border-gray-200">
                <V1FormQuestion
                  question={childQuestion}
                  primaryColor={primaryColor}
                  isConditional={true}
                />
              </div>
            );
          }
        });
    }
  });

  return conditionalQuestions.length > 0 ? <>{conditionalQuestions}</> : null;
};